<div class="card mt-4">
    <div class="text-xl font-semibold mb-4">{{ title }}</div>

    @if (races.length === 0) {
        <div class="text-muted-color p-4">
            Noch keine Rennen gefahren.
        </div>
    } @else {
        <!-- Desktop: full table -->
        <div class="hidden md:block">
            <p-table
                [value]="races"
                stripedRows="true"
                [rowHover]="true"
                [paginator]="races.length > 10"
                [rows]="10"
                sortField="day_real"
                [sortOrder]="-1"
                size="small"
            >
                <ng-template #header>
                    <tr>
                        <th pSortableColumn="position_finished">Platz <p-sortIcon field="position_finished" /></th>
                        <th pSortableColumn="group_name">Gruppe <p-sortIcon field="group_name" /></th>
                        <th pSortableColumn="day_real">Datum <p-sortIcon field="day_real" /></th>
                        <th>Saison</th>
                        <th pSortableColumn="circuits_name">Strecke <p-sortIcon field="circuits_name" /></th>
                        <th>Auto</th>
                        <th>Beste Runde</th>
                    </tr>
                </ng-template>
                <ng-template #body let-race>
                    <tr>
                        <td>
                            <p-tag
                                [value]="'P' + race.position_finished"
                                [severity]="positionSeverity(race.position_finished)"
                            />
                        </td>
                        <td>
                            @if (race.group_name) {
                                <p-tag [value]="race.group_name" severity="secondary" />
                            }
                        </td>
                        <td style="white-space: nowrap;">{{ race.day_real | date: 'dd.MM.yyyy' }}</td>
                        <td>{{ race.season_name }}</td>
                        <td class="circuit-cell">{{ race.circuits_name }}</td>
                        <td>{{ race.car_name }}</td>
                        <td>{{ race.best_lap }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <!-- Mobile: one card per race -->
        <div class="md:hidden flex flex-col gap-3">
            @for (race of visibleRaces; track $index) {
                <div class="race-card rounded-lg p-3">
                    <div class="flex items-center gap-2">
                        <p-tag
                            [value]="'P' + race.position_finished"
                            [severity]="positionSeverity(race.position_finished)"
                        />
                        <span class="font-medium">{{ race.circuits_name }}</span>
                    </div>
                    <div class="text-sm text-muted-color mt-2 flex items-center flex-wrap gap-2">
                        <span>{{ race.day_real | date: 'dd.MM.yyyy' }} · {{ race.season_name }}</span>
                        @if (race.group_name) {
                            <p-tag [value]="race.group_name" severity="secondary" />
                        }
                    </div>
                    @if (race.car_name) {
                        <div class="text-sm mt-1">{{ race.car_name }}</div>
                    }
                    @if (race.best_lap) {
                        <div class="text-sm text-muted-color mt-1">Beste Runde: {{ race.best_lap }}</div>
                    }
                </div>
            }
            @if (hasMore) {
                <p-button label="Mehr anzeigen" [text]="true" (onClick)="showMore()" styleClass="w-full" />
            }
        </div>
    }
</div>
